<template>
 	
 	<transition 
 	v-if="active"
	enter-active-class="fadeIn"
	leave-active-class="fadeOut"
	name="fade">
 	<div id="priceNotifier">
 		Priset har uppdaterats
 	</div> 
 	</transition>

</template>

<script>

export default {
  data: function(){ 
    return{
      active: false,
    }
  },

  methods: {
  	
  },

  mounted(){

  	// On show

  }

}
</script>

<style>

#priceNotifier{
	
	position: absolute;
  left: -120px;
  width: 193px;
  text-align: center;
  background: white;
  font-size: 12px;
  line-height: normal;
  border-radius: 13px;
  padding: 17px 8px;
  top: -73px;

  /* Mobile */
  @media screen and (max-width: 812px) {
    display: none;
  }

  &:after{
  	content: "";
      position: absolute;
      bottom: -16px;
      left: 50%;
      margin-left: -16px;
      border-width: 16px 16px 0;
      border-style: solid;
      border-color: #ffffff transparent;
      display: block;
      width: 0;
  };

}

</style>



// WEBPACK FOOTER //
// PriceNotifier.vue?751681d4